<template lang="html">
	<el-dialog
	  class="upload-file-dialog"
	  :title="stepTitle"
	  :fullscreen="fullscreen"
	  :visible.sync="showSelectFile"
	  :width="width">
		<div class="dialog-content">
			<div v-if="step < 3" class="dialog-content">
				<div style="flex:1;margin-bottom:2em;width:100%">
					<div style="margin:0 auto;width:60%">
						<el-steps :active="step">
							<el-step :title="$t('uploadStepName')" icon="el-icon-upload"></el-step>
							<el-step :title="$t('emailStepName')" icon="el-icon-message"></el-step>
						</el-steps>
					</div>
				</div>
				<el-upload v-if="step === 1"
				  class="upload"
				  drag
				  action="https://teamprinter.com"
				  :on-success="handleSuccess"
				  :on-remove="handleRemove"
				  :file-list="fileList"
				  :auto-upload="false"
				  :on-change="handleChange"
				  multiple>
					<i class="el-icon-upload"></i>
					<div class="el-upload__text" v-html="$t('fileSelectDialogMessage')"></div>
					<div class="disclaimer-text" slot="tip">{{ $t('fileUploadSizeDisclaimer', { maxSize: 30 }) }}</div>
				</el-upload>
				<div v-else-if="step === 2">
					<el-form ref="form" :model="user" label-width="120px" :rules="rules" label-position="top">
						<el-form-item :label="$t('userFormEmail')" prop="email">
							<el-input v-model="user.email" tabindex="1" autocomplete="true"></el-input>
						</el-form-item>
						<br/>
						<br/>
						<el-form-item :label="$t('userFormComment')" prop="comment">
							<el-input
							  tabindex="2"
							  type="textarea"
							  placeholder="Please input"
							  v-model="user.comment"
							  maxlength="5000"
							  show-word-limit
							></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div v-else>
				<div class="done-form" v-loading="step == 3" style="height:300px;width:100%">
					<div v-if="step == 4">
						<h3>{{ $t('jobCreatedFormHeading') }}</h3>
						<div class="content" v-html="$t('congratsHtmlTemplate', { email: user.email, accessCode, address: spot.address, name: spot.name })"></div>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="hide" v-if="step == 1">{{ $t('genCancel') }}</el-button>
			<el-button @click="step = 1" v-else-if="step == 2">{{ $t('genBack') }}</el-button>
			
			<el-button type="primary" :disabled="fileList.length === 0" v-if="step === 1" @click="step = 2">{{ $t('genNext') }}</el-button>
			<el-button type="primary" v-else-if="step === 2" @click="confirm">{{ $t('genSubmit') }}</el-button>

			<el-button type="primary" v-else-if="step === 4" @click="jobDone">{{ $t('genOk') }}</el-button>
		</span>
	</el-dialog>
</template>
<script>
import Logger from '@/utils/Logger.js';

export default {
	name: 'UploadFile',
	props: {
		upload: Function,
		done: Function,
		spot: Object,
		fullscreen: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		stepTitle: function () {
			switch (this.step) {
				case 1: return this.$t('fileSelectDialogSelectFileTitle');
				case 2: return this.$t('fileSelectDialogUserFormTitle');
				case 3: return this.$t('jobLoadingFormTitle') + " " +  this.percentage + "%";
				case 4: return this.$t('jobCreatedFormTitle');
			}
		}
	},
	data: () => ({
		showSelectFile: false,
		width: '30%',
		fileList: [],
		uploading: true,
		step: 1,
		user: {
			email: null,
			comment: null
		},
		rules: {
			email: [],
			comment: []
		},
		accessCode: '1234567',
		percentage: 0
	}),
	created: function () {
		let self = this;
		this.rules = {
			email: [{ required: true, type: 'email', message: self.$t('errMsgUserFormEmailRequired'), trigger: 'blur' }],
			comment: []
		};
	},
	methods: {
		setPercentage: function (p) {
			this.percentage = p;
		},
		validateForm: function (formName) {
			return new Promise((resolve) => {
				this.$refs[formName].validate(resolve);
			});
		},
		show: function () {
			this.showSelectFile = true;
		},
		hide: function () {
			this.step = 1;
			this.showSelectFile = false;
		},
		jobDone: function () {
			this.hide();
			this.step = 1;
			this.done();
		},
		cleanup: function () {
			this.fileList = [];
			this.step = 1;
		},
		confirm: async function () {
			let isValid = await this.validateForm('form');
			if (!isValid) {
				return;
			}
			this.uploading = true;
			this.step = 3;
			Logger.info(`Confirm upload ${this.fileList.length} files`);
			let err;
			[err, this.accessCode] = await this.upload(this.fileList, this.user);
			this.cleanup();
			this.uploading = false;
			if (err) {
				this.step = 1;
				this.hide();
				return;
			}
			this.step = 4;
		},
		handleSuccess: function (response, file, fileList) {
			this.fileList = fileList;
		},
		handleChange: function (file, fileList) {
			Logger.info('Next file uploaded', file);
			this.fileList = fileList;
		},
		handleRemove: function (file, fileList) {
			Logger.info('File removed', file);
			this.fileList = fileList;
		}
	}
}
</script>
<style lang="scss" scoped>
.upload-file-dialog {
	min-width:360px !important;
	margin:0 !important;
}
el-dialog {
	min-width:360px;
}
.done-form {
	width:100%;
	box-sizing: content-box;
	padding: .5em;
	h3 {
		text-align:center;
		width:100%;
		font-size: 2em;
	}
	
}
.content {
	line-height:1.5em;
	margin-top:1em;
	font-size:1.2em;
	word-break:normal;
	min-width:320px;
	box-sizing: border-box;
}
.dialog-content {
	display:flex;
	flex-direction:column;
	min-width:320px;
	justify-content:center;
}
.upload {
	display:flex;
	justify-content:center;
	flex-direction:column;
	width:100%;
}
.disclaimer-text {
	width:100%;
	text-align:center;
	margin: 1em 0 2em 0;
	font-size:0.85em;
	font-style:italic;
}


</style>


























